// Reads a Server-Sent-Events stream sent over a POST request and dispatches
// parsed events. Keeps the streaming/parsing logic out of UI components.
export async function streamChat({ url, body, signal, onMeta, onDelta }) {
  const resp = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    signal,
  });
  if (!resp.ok || !resp.body) throw new Error(`stream failed: ${resp.status}`);

  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const part of parts) {
      let event = "message";
      let dataStr = "";
      for (const ln of part.split("\n")) {
        if (ln.startsWith("event:")) event = ln.slice(6).trim();
        else if (ln.startsWith("data:")) dataStr += ln.slice(5).trim();
      }
      if (!dataStr) continue;
      const payload = JSON.parse(dataStr);
      if (event === "meta" && payload.conversation_id) onMeta?.(payload.conversation_id);
      else if (payload.delta) onDelta?.(payload.delta);
    }
  }
}
